/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import DateUtil from '../utils/DateUtil';
import {TSReportType} from './enums/TSReportType';
import moment = require('../../../node_modules/moment/moment');

export default class TSReportTypeDTO {
    private _auszahlungsDatumVon: moment.Moment | undefined;
    private _auszahlungsDatumBis: moment.Moment | undefined;
    private _ereignisDatumVon: moment.Moment | undefined;
    private _ereignisDatumBis: moment.Moment | undefined;
    private _gesuchDatumVon: moment.Moment | undefined;
    private _gesuchDatumBis: moment.Moment | undefined;
    private _reportType: TSReportType = TSReportType.AUSZAHLUNG;

    public get auszahlungsDatumVon(): moment.Moment | undefined {
        return this._auszahlungsDatumVon;
    }

    public set auszahlungsDatumVon(value: moment.Moment | undefined) {
        this._auszahlungsDatumVon = value;
    }

    public get auszahlungsDatumBis(): moment.Moment | undefined {
        return this._auszahlungsDatumBis;
    }

    public set auszahlungsDatumBis(value: moment.Moment | undefined) {
        this._auszahlungsDatumBis = value;
    }

    public get ereignisDatumVon(): moment.Moment | undefined {
        return this._ereignisDatumVon;
    }

    public set ereignisDatumVon(value: moment.Moment | undefined) {
        this._ereignisDatumVon = value;
    }

    public get ereignisDatumBis(): moment.Moment | undefined {
        return this._ereignisDatumBis;
    }

    public set ereignisDatumBis(value: moment.Moment | undefined) {
        this._ereignisDatumBis = value;
    }

    public get gesuchDatumVon(): moment.Moment | undefined {
        return this._gesuchDatumVon;
    }

    public set gesuchDatumVon(value: moment.Moment | undefined) {
        this._gesuchDatumVon = value;
    }

    public get gesuchDatumBis(): moment.Moment | undefined {
        return this._gesuchDatumBis;
    }

    public set gesuchDatumBis(value: moment.Moment | undefined) {
        this._gesuchDatumBis = value;
    }

    public get reportType(): TSReportType {
        return this._reportType;
    }

    public set reportType(value: TSReportType) {
        this._reportType = value;
    }

    serialize(restObject: any): any {
        if (this.auszahlungsDatumVon && this.auszahlungsDatumBis) {
            restObject.auszahlungsDatumVon = DateUtil.momentToLocalDateTime(this.auszahlungsDatumVon);
            restObject.auszahlungsDatumBis = DateUtil.momentToLocalDateTime(this.auszahlungsDatumBis);
        }
        if (this.ereignisDatumVon && this.ereignisDatumBis) {
            restObject.ereignisDatumVon = DateUtil.momentToLocalDate(this.ereignisDatumVon);
            restObject.ereignisDatumBis = DateUtil.momentToLocalDate(this.ereignisDatumBis);
        }
        if (this.gesuchDatumVon && this.gesuchDatumBis) {
            restObject.gesuchDatumVon = DateUtil.momentToLocalDateTime(this.gesuchDatumVon);
            restObject.gesuchDatumBis = DateUtil.momentToLocalDateTime(this.gesuchDatumBis);
        }
        restObject.reportType = this.reportType;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSReportTypeDTO.ts